import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ChangeSettingsSectionParam } from "src/app/SettingsModal/methods";
import { SettingsButtons } from "src/app/SettingsModal/components/SettingsTabContent/SettingsTabContent";
import { Button } from "src/app/components/Button/Button";
import { ReactComponent as PlusIcon } from "src/images/plus-transparent.svg";
import { CreatorContentMonitor } from "src/types";
import { RemoveModal } from "src/app/modals/RemoveModal/RemoveModal";
import {
  deleteCreatorContentMonitor,
  getCreatorContentMonitoringList,
  updateCreatorContentMonitor,
} from "src/redux";
import { RootState } from "src/redux/reducers";
import { ExtensionsSection } from "../../../Extensions";
import ExtensionView from "../../../ExtensionView";

import "./CreatorContentMonitoringList.scss";
import { CreatorContentMonitoringListItem } from "./components/CreatorContentMonitoringListItem";

interface Props {
  onClose: () => void;
  setExtensionsSection: (section: ChangeSettingsSectionParam) => void;
  openContentMonitoringDetails: (uuid: string) => void;
  createNewContentMonitoring: () => void;
}

export const CreatorContentMonitoringList = (props: Props) => {
  const {
    onClose,
    setExtensionsSection,
    openContentMonitoringDetails,
    createNewContentMonitoring,
  } = props;

  const [elementToBeDeletedData, setElementToBeDeletedData] =
    useState<CreatorContentMonitor | null>(null);

  const { creatorContentMonitors } = useSelector(
    (state: RootState) => state.extensionReducer,
  );

  const dispatch = useDispatch();
  const { projectId } = useParams<{ projectId: string }>();

  const reloadList = () => {
    setTimeout(() => {
      dispatch(getCreatorContentMonitoringList(projectId));
    }, 1000);
  };

  const toggleMonitorEnabled = async (monitor: CreatorContentMonitor) => {
    await dispatch(
      updateCreatorContentMonitor({ ...monitor, enabled: !monitor.enabled }),
    );
    reloadList();
  };

  const removeMonitor = () => {
    if (!elementToBeDeletedData) return;

    dispatch(
      deleteCreatorContentMonitor({
        uuid: elementToBeDeletedData?.uuid,
        wsProjectUuid: elementToBeDeletedData?.wsProjectUuid,
      }),
    );
    reloadList();
  };

  return (
    <ExtensionView
      navigationButtons={[
        {
          label: (
            <IDHFormattedMessage
              id="ws_extensions"
              defaultMessage="Extensions"
            />
          ),
          action: () => setExtensionsSection(ExtensionsSection.ExtensionsList),
        },
      ]}
      title={
        <IDHFormattedMessage
          id="ws_creator_content_monitoring"
          defaultMessage="Creator content monitoring"
        />
      }
      actionButton={
        <Button
          variant="blue"
          size="small"
          onClick={createNewContentMonitoring}
        >
          <PlusIcon />
          <IDHFormattedMessage id="ws_add" defaultMessage="Add" />
        </Button>
      }
    >
      <div className="creator-content-monitoring-list">
        <div className="creator-content-monitoring-list__content">
          {creatorContentMonitors.map((monitor) => (
            <CreatorContentMonitoringListItem
              key={monitor.uuid}
              monitor={monitor}
              openContentMonitoringDetails={openContentMonitoringDetails}
              toggleMonitorEnabled={toggleMonitorEnabled}
              setElementToBeDeletedData={setElementToBeDeletedData}
            />
          ))}
        </div>
        <SettingsButtons onClose={onClose} />
      </div>

      {elementToBeDeletedData && (
        <RemoveModal
          onClose={() => setElementToBeDeletedData(null)}
          objectNames={[elementToBeDeletedData.name]}
          removeFunction={removeMonitor}
        />
      )}
    </ExtensionView>
  );
};
